import ScrollMagic from 'scrollmagic';
import Controller from '../controller';

document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('header');

  return new ScrollMagic.Scene({
    triggerElement: document.body,
    triggerHook: 'onLeave',
    offset: 30,
  })
    .setClassToggle(header, 'is-dark')
    .addTo(Controller);
});



// WEBPACK FOOTER //
// ./scripts/utils/scrollmagic/scenes/header.js